import { forwardRef, memo, useCallback } from 'react';
// Material UI imports
import Box from '@mui/material/Box';
// Skillmore UI Components
import CheckboxButton from '@empathco/ui-components/src/elements/CheckboxButton';
// SCSS imports
import { label } from './PreferencesCheckbox.module.scss';

type PreferencesCheckboxProps = {
  readonly id: string;
  readonly title: string;
  readonly value: boolean;
  readonly onChange: (id: string) => void;
  readonly disabled?: boolean | null;
}

const PreferencesCheckbox = forwardRef<HTMLButtonElement, PreferencesCheckboxProps>(({
  id,
  title,
  value,
  onChange,
  disabled = false
}, ref) => {
  const handleChange = useCallback(() => onChange(id), [id, onChange]);
  return (
    <>
      <CheckboxButton
          ref={ref}
          label={title}
          checked={value}
          onChange={handleChange}
          disabled={disabled ? true : undefined}
      />
      <Box
          pl={1.5}
          flexGrow={1}
          flexBasis={0}
          display="flex"
          alignItems="center"
          className={label}
      >
        {title}
      </Box>
    </>
  );
});

PreferencesCheckbox.displayName = 'PreferencesCheckbox';

export default memo(PreferencesCheckbox);
